import React from 'react';
import { CustomCalendar } from './CustomCalendar';
import { CustomTimePicker } from './CustomTimePicker';

interface VisitDataSectionProps {
  formData: any;
  setFormData: (data: any) => void;
  visitConfig: any;
  minDate: string;
  labelStyle: string;
  inputStyle: string;
  isSameDay: boolean;
  DAYS_ORDER: string[];
}

export const VisitDataSection: React.FC<VisitDataSectionProps> = ({
  formData, setFormData, visitConfig, minDate, labelStyle, inputStyle, isSameDay, DAYS_ORDER
}) => {
  return (
    <section className="space-y-4">
      <h4 className="text-sm font-black text-[#00234F] uppercase border-b pb-2">Datos de la Visita</h4>
      <div className="bg-sky-50 p-4 rounded-2xl border border-sky-100">
        <p className="text-[11px] text-sky-900 font-black uppercase mb-2">Reglas vigentes:</p>
        <ul className="space-y-1">
          {DAYS_ORDER.map(d => visitConfig?.HORARIO?.[d] && (
            <li key={d} className="text-[10px] text-sky-800 flex items-center gap-2">
              <div className="w-1 h-1 bg-sky-400 rounded-full"></div>
              {d.toLowerCase()}: <strong>{visitConfig.HORARIO[d].INICIO}:00 a {visitConfig.HORARIO[d].FIN}:00</strong>
            </li>
          ))}
        </ul>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-2">
        {[1, 2].map(i => (
          <div key={i} className={`space-y-3 p-5 rounded-2xl border shadow-inner transition-all ${isSameDay ? 'bg-red-50 border-red-200' : 'bg-gray-50 border-gray-100'}`}>
            <p className={`text-[9px] font-black uppercase tracking-widest border-b pb-1 ${isSameDay ? 'text-red-400 border-red-100' : 'text-gray-400 border-gray-100'}`}>Opción {i === 1 ? 'Preferida *' : 'Alternativa *'}</p>
            <div><label className={labelStyle}>Fecha *</label><CustomCalendar value={(formData as any)[`fecha${i}`]} onChange={v => setFormData({...formData, [`fecha${i}`]: v})} minDate={minDate} visitConfig={visitConfig} /></div>
            <div><label className={labelStyle}>Hora *</label><CustomTimePicker value={(formData as any)[`hora${i}`]} date={(formData as any)[`fecha${i}`]} onChange={v => setFormData({...formData, [`hora${i}`]: v})} visitConfig={visitConfig} /></div>
          </div>
        ))}
      </div>
      {isSameDay && (
        <div className="bg-red-100 p-3 rounded-xl border border-red-200 flex items-center gap-2 animate-shake">
          <div className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></div>
          <p className="text-[10px] text-red-700 font-bold uppercase tracking-tight">
            Las dos fechas de visita no pueden ser el mismo día. Por favor elige días diferentes.
          </p>
        </div>
      )}
      <div className="space-y-4 pt-4 border-t border-gray-100">
        <h4 className="text-sm font-black text-[#00234F] uppercase border-b pb-2">
          ¿Quién recogerá las llaves para la visita?
        </h4>

        <div className="flex gap-6">
          <label className="flex items-center gap-2 cursor-pointer text-sm font-semibold text-gray-700">
            <input 
              type="radio" 
              name="llaves_quien" 
              value="broker" 
              checked={formData.llaves_quien === 'broker' || !formData.llaves_quien} 
              onChange={() => setFormData({ ...formData, llaves_quien: 'broker' })}
              className="text-sky-600 focus:ring-sky-500 h-4 w-4 border-gray-300"
            />
            Broker {formData.nombre_broker ? `(${formData.nombre_broker})` : ''}
          </label>
          <label className="flex items-center gap-2 cursor-pointer text-sm font-semibold text-gray-700">
            <input 
              type="radio" 
              name="llaves_quien" 
              value="otro" 
              checked={formData.llaves_quien === 'otro'} 
              onChange={() => setFormData({ ...formData, llaves_quien: 'otro' })}
              className="text-sky-600 focus:ring-sky-500 h-4 w-4 border-gray-300"
            />
            Otro
          </label>
        </div>

        {formData.llaves_quien === 'otro' && (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 p-4 bg-gray-50 rounded-2xl border border-gray-100 animate-fade-in">
            <div>
              <label className={labelStyle}>Nombre *</label>
              <input 
                type="text" 
                value={formData.llaves_nombre || ''} 
                onChange={e => setFormData({ ...formData, llaves_nombre: e.target.value })}
                className={inputStyle}
                placeholder="Nombre completo"
              />
            </div>
            <div>
              <label className={labelStyle}>Teléfono *</label>
              <input 
                type="text" 
                value={formData.llaves_telefono || ''} 
                onChange={e => setFormData({ ...formData, llaves_telefono: e.target.value })}
                className={inputStyle}
                placeholder="Número de celular"
              />
            </div>
            <div>
              <label className={labelStyle}>Número de Identificación *</label>
              <input 
                type="text" 
                value={formData.llaves_documento || ''} 
                onChange={e => setFormData({ ...formData, llaves_documento: e.target.value })}
                className={inputStyle}
                placeholder="C.C. o pasaporte"
              />
            </div>
          </div>
        )}
      </div>

      <div><label className={labelStyle}>Notas de la visita</label><textarea value={formData.descripcion} onChange={e => setFormData({...formData, descripcion: e.target.value})} className={`${inputStyle} h-24 resize-none`} placeholder="Ej: Cliente interesado en el balcón..." /></div>
    </section>
  );
};
